module.exports = __webpack_public_path__ + "static/media/jose.9d31b1b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/eshopex/jose.jpg
// module id = 1214
// module chunks = 0